export const VideoPlayer = ({ src, className }) => {
    return (
        <iframe
            id="ytplayer"
            type="text/html"
            className={className}
            src={src}
            frameBorder="0"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        >
        </iframe>
    )
}